<template>
    <ion-page>
      <div class="overlay" v-if="currentTab !== 'match-detail'">
        <ion-toolbar lines="none" translucent class="menu-toolbar">
          <ion-buttons slot="start" @click="goPrev()">
            <div class="pl-05">
              <ion-icon :icon="chevronBackOutline" size="large" />
            </div>
          </ion-buttons>
          <ion-title size="medium">{{appTitle}}</ion-title>
        </ion-toolbar>
      </div>
      <ion-content class="menu-content">
        <!-- <p class="pl-30 mt-20 c-white">State</p>
        <h3 class="pl-30 c-white">{{ loading ? '----' : appTitle }}</h3> -->

        <div class="welcome mb-2 mt-10 d-flex flex-column justify-center align-center">
          <img :src="assocLogo" alt="" srcset="" class="logo">
          <h3 class="c-white">{{ appTitle }}</h3>
        </div>
        
        <div class="px-20">
          <ion-segment class="custom-segment" color="dark" v-model="currentOption" style="{'border-radius': '0.6rem !important'}" :key="key">
            <ion-segment-button  :value="capitalize(presentation.associationDirectChild)" @click="currentOption = capitalize(presentation.associationDirectChild)">
              <ion-label>{{ capitalize(presentation.associationDirectChild) }}</ion-label>
            </ion-segment-button>
            <ion-segment-button value="Competitions" @click="currentOption = 'Competitions'">
              <ion-label>Competitions</ion-label>
            </ion-segment-button>
            <ion-segment-button value="Ladders" @click="currentOption = 'Ladders'">
              <ion-label>Ladders</ion-label>
            </ion-segment-button>
            <ion-segment-button value="Leaderboards" @click="currentOption = 'Leaderboards'">
              <ion-label>Leaderboards</ion-label>
            </ion-segment-button>
          </ion-segment>
        </div>
        <div class="season-select" v-if="currentOption === 'Competitions'">
          <ion-item lines="none" class="px-20">
            <ion-label>Season</ion-label>
            <ion-select v-model="filterSeason">
              <ion-select-option v-for="season in seasons" :key="season._id" :value="season._id">{{ season._id }}</ion-select-option>
            </ion-select>
          </ion-item>
        </div>
        <div class="state-section" v-if="currentOption === capitalize(presentation.associationDirectChild)">
          <!-- <div class="d-flex justify-between align-center c-white px-20">
            <h4 class="font-light">Associations</h4>
          </div> -->
          <div class="state-list" :key="key">
            <entity-card v-for="club in clubs" :entity="club" :key="club._id" @click="menuNavigation(`/${presentation.associationDirectChild}/${club._id}`)" />
          </div>
        </div>
        <div class="competition-section" v-if="currentOption === 'Competitions'">
          <CompetitionCard v-for="comp in filteredCompetitions" :comp="comp" :key="comp._id" @click="menuNavigation(`/competitions/${comp._id}`)" />
        </div>
        <div class="ladder-section mt-1" v-if="currentOption === 'Ladders'">
          <Ladders entityType="association" :entityId="$route.params.id" />
        </div>
        <div class="leaderboard-section mt-1" v-if="currentOption === 'Leaderboards'">
          <Leaderboards entityType="association" :entityId="$route.params.id" />
        </div>
      </ion-content>
    </ion-page>
  </template>
  
<script>
import {
  flagOutline,
  podiumOutline,
  arrowBackOutline,
  arrowForwardOutline,
  caretDownOutline,
  chevronBackOutline,
  menuSharp,
  closeOutline
} from "ionicons/icons";
import { menuController } from "@ionic/vue";
import TeamLogo from '../matches/base/team-logo.vue'
import CompetitionCard from '../../components/CompetitionCard.vue'
import EntityCard from '../../components/EntityCard.vue'
import Ladders from '../modules/Ladders.vue'
import Leaderboards from '../modules/Leaderboard.vue'
import _ from 'lodash';
// import moment from 'moment';
export default {
  components: {
    TeamLogo,
    CompetitionCard,
    EntityCard,
    Ladders,
    Leaderboards,
  },
  props: {
    entityLevel: String,
    entityName: String,
  },
  setup() {
    return {
      flagOutline,
      podiumOutline,
      arrowBackOutline,
      arrowForwardOutline,
      chevronBackOutline,
      caretDownOutline,
      closeOutline,
      menuSharp
    }
  },
  data() {
    // const { filter } = this.$store.state.matches;
    return {
      associations: [],
      key: 1,
      loading: false,
      association: undefined,
      competitions: [],
      currentOption: 'Competitions',
      seasonFilter: false,
      filterSeason: undefined,
    };
  },
  created() {
    this.searchstate = _.debounce(async function(e) {
      const search = e.target.value;
      this.loading = true;
      const resState = await this.$http.get(`/assemble/api/v1/live/associations/${this.$route.params.id}`);
      this.clubs = resState.data.clubs;
      this.association = resState.data.association;
      this.competitions = resState.data.competitions;
      this.loading = false;
      this.key++;
    }, 500);
  },
  beforeMount() {
    const seasons = this.$store.getters['national/seasons'];
    const currentSeason = _.find(seasons, (season) => _.get(season, 'currentSeason', false) === true);
    if (currentSeason) {
      this.filterSeason = currentSeason._id;
    }
  },
  async mounted() {
    try {
      this.$store.dispatch('national/setup');
      this.loading = true;
      const resState = await this.$http.get(`/assemble/api/v1/live/associations/${this.$route.params.id}`);
      this.clubs = resState.data[this.presentation.associationDirectChild];
      this.association = resState.data.association;
      this.competitions = resState.data.competitions;
      this.loading = false;
      this.key++;
    } catch (error) {
      console.log(error); 
    }
    // loadingController
    //   .create({ message: "Loading competitions..." })
    //   .then(loading => {
    //     loading.present();
    //   });
  },
  updated() {
    if (this.preferredTab) {
      this.currentOption = this.preferredTab;
    }
  },  
  computed: {
    preferredTab() {
      return this.$store.getters['ui/preferredTab'];
    },
    assocLogo() {
      return this.association ? _.get(this, 'association.meta.imgUrl') : '';
    },
    submenu() {
      return ['Competitions', this.capitalize(this.presentation.associationDirectChild)];
    },
    presentation() {
      return this.$store.getters['national/presentation'];
    },
    appTitle() {
      return this.association ? this.association.name : process.env.VUE_APP_BANNER_TITLE;
    },
    seasons(){
      return this.$store.state.national.seasons;
    },
    // seasons() {
    //   return this.competitions.map(comp => comp.season).filter((v, i, a) => a.findIndex(t => (t._id === v._id)) === i);
    // },
    filteredCompetitions() {
      const sortedCompetition = _.orderBy(_.cloneDeep(this.competitions), ['order'], ['asc']);
      if(this.seasonFilter) {
        return sortedCompetition.filter(comp => comp.season._id === this.season);
      }
      return sortedCompetition;
    },
    availableTabs() {
      return ['Competitions', this.capitalize(this.presentation.associationDirectChild), 'Ladders', 'Leaderboards'];
    },
    entity() {
      return this.$store.getters['national/getEntity'];
    },
  },
  methods: {
    capitalize(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    menuNavigation(url){
      menuController.close("side");
      if(this.entity && this.entityLevel && this.entityName){
        url = `/c/${this.entityLevel}/${this.entityName}${url}`
      }
      this.$router.push(url);
    },
    goPrev() {
      this.$router.go(-1);
    },
    openMenu() {
      // menuController.enable(true, 'side');
      menuController.open('side');
    },
  },
  watch: {
    filterSeason: {
      async handler(id) {
        if(!id) return;
        try {
          this.loading = true;
          const resComp = await this.$http.get(`/assemble/api/v1/live/associations/${this.$route.params.id}`, {
            params:{
              season: this.filterSeason,
            }
          });
          console.log({
            resComp
          });
          this.competitions = _.get(resComp, 'data.competitions', []);
          this.loading = false;
        } catch (error) {
          console.log(error);
        }
  
        this.loading = false;
      },
      immediate: true,
    },
    presentation: {
      deep: true,
      handler() {
        if (this.preferredTab && this.availableTabs.includes(this.preferredTab)) {
          this.currentOption = this.preferredTab;
          return;
        }
        this.currentOption = this.capitalize(this.presentation.associationDirectChild);
        // this.$forceUpdate();
        // this.key++;
      }
    },
    currentOption: {
      handler(val) {
        this.$store.commit('ui/updatePreferredTab', val);
      },
      immediate: false,
    }
  }
};
</script>
  <style scoped lang="scss">
  
  .logo {
    max-width: clamp(5rem, 20vw, 15rem);
    background: $background;
  }

  ion-title {
    font-family: 'Cairo';
  }
  
  ion-grid {
    white-space: nowrap;
     --offset-bottom: auto!important;
    --overflow: hidden;
    overflow: auto;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  
  ion-segment {
    --background: #191a1d !important;
  }
  
  .team-logo-preview {
    display: flex;
    .club-logo {
      margin-right: -0.5rem;
      z-index: 10;
    }
    margin-bottom: 2rem;
  }
  
  .team-plus {
    width: 2rem;
    height: 2rem;
    background: rgb(52, 52, 52);
    border: 1px solid #3c3c3c;
    color: white;
    border-radius: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.8rem;
  }
  .option-row {
    display: flex;
    --offset-bottom: auto!important;
    --overflow: hidden;
    overflow: auto;
    &::-webkit-scrollbar {
      display: none;
    }
    background: $background !important;
  }
  
  .competition-section {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(10rem, 1fr));
    // on larger screen make it bigger
    @media only screen and (min-width: 768px) {
      grid-template-columns: repeat(auto-fit, minmax(15rem, 20rem));
    }
    gap: 0.5rem;
    padding: 1rem 1rem;
    .competition-option {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      // align-items: center;
      // gap: 0.5rem;
      background: #17181B;
      border-radius: 1rem;
      padding: 1rem 1rem;
      // min-width: 10rem;
    }
  }
  
  
  .chip {
    font-size: 1rem;
    color: #a9a9a9;
    font-family: 'Cairo';
    &.active {
      background: var(--highlight-color);
      ion-label {
        color: #000;
      }
      // color: var(--ion-color-primary);
      font-family: 'Cairo';
    }
  
    &.selectable {
      cursor: pointer;
      color: #a9a9a9;
      background: #1E1F22;
    }
  }
  
  .header-bar {
    padding: 0.5rem;
  }
  
  .search-bar {
    color: #fff;
    margin: 1rem 2rem;
    max-width: 85%;
    background: #191a1d !important;
    border: 1px solid #616161;
    border-radius: 1rem;
    .searchbar-input-container { 
      
    }
  }
  
  
  .round-text {
    color: #fff;
    font-family: 'Cairo';
    text-align: center;
    font-size: 14px;
    text-transform: uppercase;
    // text-decoration: underline;
    // text-decoration-color: $highlight;
  }
  
  .state-list {
    margin: 1rem;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(10rem, 1fr));

    @media only screen and (min-width: 768px) {
      grid-template-columns: repeat(auto-fit, minmax(15rem, 20rem));
    }
    gap: 0.5rem;
    .state-option {
      display: grid;
      // flex-direction: column;
      // justify-content: center;
      align-items: center;
      gap: 0.5rem;
      background: #17181B;
      border-radius: 1rem;
      padding: 1rem 1rem;
    }
  }
  
  ion-label {
    color: white;
    font-family: 'Cairo';
    font-size: 0.8rem;
  }
  
  
  ion-item {
    --padding-start: 15px;
    --padding-end: 15px;
  }
  .flex {
    display: flex;
  }
  .flex-column {
    flex-direction: column;
  }
  .align-center {
    align-items: center;
  }
  .justify-end {
    justify-content: flex-end;
  }
  .justify-center {
    justify-content: center;
  }
  .justify-between {
    justify-content: space-between;
  }
  .justify-around {
    justify-content: space-around;
  }
  .light-text {
    font-size: 14px;
    font-weight: 400;
    text-transform: capitalize;
  }
  .normal-text {
    font-size: 15px;
    font-weight: 600;
    text-transform: capitalize;
  }
  .bold-text {
    font-size: 16px;
    font-weight: bold;
  }
  .score-text {
    font-size: 30px;
    line-height: 30px;
    font-weight: 700;
    /* color: rgba(8, 48, 109, 0.5); */
    color: white;
  }
  
  .header {
    --background: #1a2933 !important;
    color: white;
  }
  
  .custom-segment {
    background: $background !important;
  }
  
  .custom-segment ::before {
    border-left: none;
  }
  
  ion-segment-button::part(indicator-background) {
    background: hsl(225, 7%, 16%);
  }
  
  /* Material Design styles */
  ion-segment-button.md {
    --color: white;
    --color-checked: #191a1d;
    --indicator-height: 4px;
  }
  
  /* iOS styles */
  ion-segment-button.ios {
    --color: white;
    --color-checked: #191a1d;
    --border-radius: 20px;
  }
  
  .bye-card {
    margin-inline: 1.5rem;
    position: relative;
    border-radius: 24px;
    cursor: pointer;
    box-shadow: inset 0 0 0 1000px rgba(117, 125, 138, .25);
    -webkit-box-shadow: inset 0 0 0 1000px rgba(117, 125, 138, .25);
    
    font-family: 'BrownStd-Regular';
    color: white;
    background: transparent;
    .round-text {
      margin-top: 0.5rem;
      margin-bottom: 1rem;
    }
  }
  .custom-card {
    border-radius: 24px;
    cursor: pointer;
    // box-shadow: inset 0 0 0 1000px rgba(117, 125, 138, .25);
    // -webkit-box-shadow: inset 0 0 0 1000px rgba(117, 125, 138, .25);
    font-family: 'BrownStd-Regular';
    font-size: 1.2rem;
    line-height: 137.4%;
    letter-spacing: 0.02em;
    color: white;
     box-shadow: none;
    background: #171717 !important;
    margin-inline: 1.5rem;
  }
  .custom-card .card-content-ios {
    padding: 10px;
  }
  
  .custom-card .promoted-header {
    font-family: 'BrownStd-Regular';
    text-align: center;
    font-size: .9rem;
    font-weight: 600;
    text-transform: capitalize;
    line-height: 137.4%;
    letter-spacing: 0.02em;
    color: #2d3a45;
  }
  
  .list-ios, .list-md {
    padding: 0;
    background: 0;
  }
  
  ion-item {
    --background: #232528;
    --color: white;
  }
  
  .custom-segment ion-label {
    margin-bottom: 0;
  }
  
  ion-content {
    background: $background;
    --background: $background;
    --offset-bottom: auto!important;
    --overflow: hidden;
    overflow: auto;
  }
  
  ion-content::-webkit-scrollbar-track
  {
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    background-color: rgba(0,0,0,0.3);
  }
  
  ion-content::-webkit-scrollbar
  {
    width: .35rem;
    background-color: rgba(0,0,0,0.3);
  }
  
  @media only screen and (max-width: 768px) {
    ion-content::-webkit-scrollbar {
      width: .15rem;
      background-color: rgba(0,0,0,0.3);
    }
  }
  
  ion-content::-webkit-scrollbar-thumb
  {
    background-color: #888;
  }
  
  
  .overlay {
    background: $background;
    // background: $primary;
    padding: 0rem;
  }
  
  ion-toolbar, ion-item {
    --border-width: 0 !important;
    --background: $background;
    --color: white;
  }
  
  ion-segment-button {
    --background-hover: #191a1d !important;
    --color-hover: #191a1d !important;
    --color-checked: #191a1d !important;
  }
  
  .custom-segment {
    border: none;
    /* background: white; */
    border-radius: 0px;
    border-bottom: 1px solid rgba(177, 177, 177, 0.3);
    // padding-top: 1rem;
    border: none;
    background: none;
     display: flex;
    // justify-content: center;
    /* border-radius: 1rem !important; */
  }
  
  .custom-segment ::before {
    border-left: none;
  }
  
  .custom-segment-ladder {
    // border: none;
    margin: 0 auto;
    margin-top: 1rem;
    display: flex;
    width:70%;
    justify-content: center;
    border-radius: 0.6rem !important;
  }
  
  .custom-segment-ladder-button{
    flex-basis: 50%;
  }
  
  
  .custom-segment-ladder ::before {
    border-left: none;
  }
  
  .empty-container {
    height: 60vh;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: none;
    -webkit-box-shadow: none;
  }
  
  .empty-container ion-card {
    padding: 4rem;
    border-radius: 1rem;
    background: transparent;
    box-shadow: none;
    -webkit-box-shadow: none;
  }
  
  .empty-placeholder {
    align-items: flex-start;
    font-family: 'BrownStd-Regular';
    font-style: normal;
    font-weight: bold;
    font-size: 1.2rem;
    line-height: 137.4%;
    /* margin-bottom: 1rem; */
    padding-left: 0;
  
    letter-spacing: 0.02em;
  
    color: white;
  }
  
  .state-name {
    font-size: 0.8rem;
    white-space: break-spaces;
  }
  
  ion-select::part(icon) {
    margin-left: 0.5rem;
    color: white !important;
    opacity: 0.85;
  }
  
  </style>